import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import logo from './logo.png';
import './App.css';
import { hasProfileAccessToResource } from './services/AuthorizationSimulator';
import EmployeeCard from './components/employee/EmployeeCard';
import NewEmployee from './components/employee/NewEmployee';
import NewReview from './components/review/NewReview';
import UpdateEmployee from './components/employee/UpdateEmployee';
import UpdateReview from './components/review/UpdateReview';
import EmployeeList from './components/employee/EmployeeList';
import ReviewList from './components/review/ReviewList';
import ReviewCard from './components/review/ReviewCard';
import About from './components/About';


/**
 * Main component where Routes are defined
 */
class App extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      profile: ''
    };
  }

  getToday = () => {
    const newDate = new Date();
    const formatter = new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit"
    });
    return formatter.format(newDate);
  }

  handleClick = (profile) => (this.setState({ profile: profile }))
  
  hasAccess = (resource) =>  hasProfileAccessToResource(this.state.profile, resource)
  
  render() {
    return (
      <Router>
        <Fragment>
          <section className='ph2 ph2-ns pv1'>
            <article className='br2 ba bg-black-10 dark-green'>
              <div className='dt-ns dt--fixed-ns w-100'>
                <Link className='dtc-ns v-mid' to='/'>
                  <img src={logo} className='br4 ba h4 w4' alt='avatar' />
                </Link>
                <div className='pa1 pa1-ns dtc-ns v-mid'>
                  <div>
                    <h2 className='fw5 f3 f2-ns lh-title mt0 mb3'>
                      Basic Full Stack Showcase
                    </h2>
                  </div>
                </div>
                <div className='dtc-ns v-mid'>
                  <script
                    type='IN/MemberProfile'
                    data-id='https://www.linkedin.com/in/alejandrochang'
                    data-format='inline'
                    data-related='false'
                  />
                  <p className='f6 lh-copy gray mv0'>
                    <span className='ttu'>Toronto, Canada</span>
                  </p>
                  <time className='f6 db gray'>
                    {this.getToday()}
                  </time>
                </div>
              </div>
              <div className='tc'>
                <button
                  onClick={(e) => this.handleClick('admin', e)}
                  className='f6 bg-dark-green no-underline washed-green ba b--dark-green grow pv2 ph3 dib mr3'
                >
                  Simulate Admin menu
                </button>
                <button onClick={(e) => this.handleClick('employee', e)}
                  className='f6 bg-dark-green no-underline washed-green ba b--dark-green grow pv2 ph3 dib mr3'
                >
                  Simulate Employee menu
                </button>
              </div>
            </article>
          </section>
          <nav className='pa2 pa2-ns mh4'>
            <Link to='/'>
              <h3 className={this.hasAccess('home') ? 'link dim black b f6 f5-ns dib mr3' : 'dn'}>Home</h3>
            </Link>
            <Link to='/reviews'>
              <h3 className={this.hasAccess('reviews') ? 'link dim gray f6 f5-ns dib mr3' : 'dn'}>Reviews</h3>
            </Link>
            <Link to='/employees'>
              <h3 className={this.hasAccess('employees') ? 'link dim gray f6 f5-ns dib mr3' : 'dn'}>Employees</h3>
            </Link>
            <Link to='/add-employee'>
              <h3 className={this.hasAccess('create-employee') ? 'link dim gray f6 f5-ns dib mr3' : 'dn'}>Add new employee</h3>
            </Link>
            <Link to='/add-review'>
              <h3 className={this.hasAccess('create-review') ? 'link dim gray f6 f5-ns dib' : 'dn'}>Add new review</h3>
            </Link>
          </nav>
          <section className='cf'>
            <div className='fl w-90 tl'>
              <section className='ph5 pv2'>
                <Switch>
                  <Route exact path='/' component={About} />
                  <Route path='/employee-card/:id' component={EmployeeCard} />
                  <Route path='/employees' component={EmployeeList} />
                  <Route path='/add-employee' component={NewEmployee} />
                  <Route path='/edit-employee/:id' component={UpdateEmployee} />
                  <Route path='/review-card/:id' component={ReviewCard} />
                  <Route path='/reviews' component={ReviewList} />
                  <Route path='/add-review' component={NewReview} />
                  <Route path='/edit-review/:id' component={UpdateReview} />
                </Switch>
              </section>
            </div>
          </section>
        </Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js